import { appSettings } from '@/environment'

const ar = {
    id: 1,
    name: 'Argentina',
    code: 'AR',
    flag: '/img/ar.svg',
    headerLogo: '/img/logo-home.svg',
    headerImage: '/img/homebg-01.jpg',
    header1: 'La manera más simple de buscar tu propiedad.',
    header2: 'Comienza ahora.',
    header3: appSettings.appName,
    head: {
        tHome: 'Departamentos en venta, alquiler temporario y permanente, casas, oficinas, locales, campos y más inmuebles: ' + appSettings.appName,
        dHome:
            'Departamentos en venta, alquiler temporal o permanente. Casas en venta y alquiler. Venta y Alquiler de locales y oficinas. Campos en venta y alquiler. Miles de ciudades para buscar propiedades.',
        tSearch: 'Es fácil encontrar propiedades: departamentos, casas, oficinas, locales, campos y más en ' + appSettings.appName,
        dSearch:
            'Miles de propiedades en venta o alquiler: departamentos y casas, alquiler temporario o permanente, alquiler de campos, oficinas y locales. En Argentina y más.'
    },
    search: {
        title: 'Encontrá tu propiedad facilmente en ' + appSettings.appName ,
        text:
            'Podés filtrar por Zona, Precio, Tipo de propiedad, Operación y más. Es fácil contactarte y decidir.'
    },
    contentTabs: [
        {
            key: 1,
            routes: [
                {
                    name: 'PH en venta en El Palomar',
                    route: '/ar/buscar/operacion-venta_1/tipo-ph_10/zona-el-palomar-moron-buenos-aires_2-222-50'
                },
                {
                    name: 'Casas en Venta en El Palomar',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-el-palomar-moron-buenos-aires_2-222-50'
                },
                {
                    name: 'Departamentos en Venta en Haedo',
                    route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-haedo-moron-buenos-aires_2-222-52'
                },
                {
                    name: 'Departamentos en Venta en Ramos Mejía',
                    route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-ramos-mejia-la-matanza-buenos-aires_2-201-1006'
                },
                {
                    name: 'Cochera en Venta en Ramos Mejía',
                    route: '/ar/buscar/operacion-venta_1/tipo-cochera_6/zona-ramos-mejia-la-matanza-buenos-aires_2-201-1006'
                },
                {
                    name: 'Departamentos en Alquiler en Haedo',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-haedo-moron-buenos-aires_2-222-52'
                },
                {
                    name: 'Departamentos en Alquiler en Ramos Mejía',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-ramos-mejia-la-matanza-buenos-aires_2-201-1006'
                },
                {
                    name: 'Cochera en Alquiler en Ramos Mejía',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-cochera_6/zona-ramos-mejia-la-matanza-buenos-aires_2-201-1006'
                },
                {
                    name: 'Alquileres en Ramos Mejía',
                    route: '/ar/buscar/operacion-alquiler_2/zona-ramos-mejia-la-matanza-buenos-aires_2-201-1006'
                },
                {
                    name: 'Departamentos de 2 ambientes en Haedo',
                    route: '/ar/buscar/tipo-departamento_1/zona-haedo-moron-buenos-aires_2-222-52/dormitorios_1'
                },
                {
                    name: 'Venta de Departamento en Morón',
                    route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-moron-buenos-aires_2-222'
                },
                {
                    name: 'Venta de Casas en Morón',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-moron-buenos-aires_2-222'
                },
                {
                    name: 'Venta de PH en Morón',
                    route: '/ar/buscar/operacion-venta_1/tipo-ph_10/zona-moron-buenos-aires_2-222'
                },
                {
                    name: 'Venta de Casa en Ituzaingó',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-ituzaingo-buenos-aires_2-88'
                },
                {
                    name: 'Venta de Duplex en Ituzaingó',
                    route: '/ar/buscar/operacion-venta_1/tipo-duplex_11/zona-ituzaingo-buenos-aires_2-88'
                },
                {
                    name: 'Venta de Departamento en Ituzaingó',
                    route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-ituzaingo-buenos-aires_2-88'
                },
                {
                    name: 'Venta de Lote en Ituzaingó',
                    route: '/ar/buscar/operacion-venta_1/tipo-terreno_4/zona-ituzaingo-buenos-aires_2-88'
                },
                {
                  name: 'Venta de Departamento en Villa Luzuriaga',
                  route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-villa-luzuriaga-la-matanza-buenos-aires_2-201-129'
                },
                {
                  name: 'Venta de Departamento en San Justo',
                  route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-san-justo-la-matanza-buenos-aires_2-201-116'
                },
                {
                    name: 'Venta de Casa en Castelar',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-castelar-moron-buenos-aires_2-222-51'
                },
                {
                    name: 'Venta de Departamento en Castelar',
                    route: '/ar/buscar/operacion-venta_1/tipo-departamento_1/zona-castelar-moron-buenos-aires_2-222-51'
                },
                {
                    name: 'Venta de Duplex en Castelar',
                    route: '/ar/buscar/operacion-venta_1/tipo-duplex_11/zona-castelar-moron-buenos-aires_2-222-51'
                },
                {
                    name: 'Venta de Lote / Terreno en Castelar',
                    route: '/ar/buscar/operacion-venta_1/tipo-terreno_4/zona-castelar-moron-buenos-aires_2-222-51'
                },
                {
                    name: 'Venta de Casa en Hurlingham',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-hurlingham-buenos-aires_2-196'
                },
                {
                    name: 'Venta de Casa en Villa Tesei',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-villa-tesei-hurlingham-buenos-aires_2-196-48'
                },
                {
                    name: 'Venta de Casa en Parque Leloir',
                    route: '/ar/buscar/operacion-venta_1/tipo-casa_2/zona-parque-leloir-ituzaingo-buenos-aires_2-88-71'
                },
                {
                    name: 'Venta de Lote en Merlo, Buenos Aires',
                    route: '/ar/buscar/operacion-venta_1/tipo-terreno_4/zona-merlo-buenos-aires_2-218'
                },
                {
                    name: 'Argentina página de alquiler',
                    route: '/ar'
                },
                {
                    name: 'Buenos Aires alquiler de casas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-buenos-aires_2'
                },
                {
                    name: 'Capital (CABA) alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Centro y Microcentro CABA alquiler',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-oficina_7/zona-microcentro-capital-federal_1-24'
                },
                {
                    name: 'Zona Norte alquiler de casas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-pilar-pilar-buenos-aires_2-232-104'
                },
                {
                    name: 'Mar del Plata alquiler de departamentos',
                    route:
                        '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-mar-del-plata-general-pueyrredon-buenos-aires_2-189-973'
                },
                {
                    name: 'Villa Gesell alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-villa-gesell-villa-gesell-buenos-aires_2-268-1111'
                },
                {
                    name: 'Ciudad Autónoma de Buenos Aires Alquileres ',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Ciudad de Córdoba alquileres',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-cordoba-capital-cordoba_6-272'
                },
                {
                    name: 'Rosario alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-rosario-rosario-santa-fe_21-312-1948'
                },
                {
                    name: 'Santa Fé alquiler ',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-santa-fe_21'
                },
                {
                    name: 'Bariloche alquiler temporario en Patagonia',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-bariloche-rio-negro_16-600'
                },
                {
                    name: 'Misiones alquiler de casas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-misiones_14'
                },
                {
                    name: 'Salta alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-salta_17'
                },
                {
                    name: 'Mendoza alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-mendoza_13'
                },
                {
                    name: 'Costa Atlántica alquiler departamentos',
                    route:
                        '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-mar-del-plata-general-pueyrredon-buenos-aires_2-189-973'
                },
                {
                    name: 'Neuquén alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-neuquen_15'
                },
                {
                    name: 'La Pampa alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-la-pampa_11'
                },
                {
                    name: 'Río Negro alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-rio-negro_16'
                },
                {
                    name: 'Tucumán alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-tucuman_24'
                },
                {
                    name: 'San Luis alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-san-luis_19'
                },
                {
                    name: 'Entre Ríos alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-entre-rios_8'
                },
                {
                    name: 'Pilar alquiler de casas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-pilar-pilar-buenos-aires_2-232-104'
                },
                {
                    name: 'Distrito Tecnológico CABA alquiler',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-parque-patricios-capital-federal_1-54'
                }
            ]
        },
        {
            key: 2,
            routes: [
                {
                    name: 'Alquiler oficinas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-oficina_7/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler cochera o garage',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-cochera_6/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler locales comerciales',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler galpón o depósito',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-galpon_8/zona-buenos-aires_2'
                },
                {
                    name: 'Alquiles terrenos y espacios',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-terreno_4/zona-buenos-aires_2'
                },
                {
                    name: 'Alquiler campos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-campo_5/zona-buenos-aires_2'
                },
                {
                    name: 'Alquiler casas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-buenos-aires_2'
                },
                {
                    name: 'Alquiler negocios y fondos de comercio',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-fondo-comercio_12/zona-buenos-aires_2'
                },
                {
                    name: 'Alquiler loft',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-loft_20/zona-argentina_1'
                },
                {
                    name: 'Alquiler habitacional',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler PH',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-ph_10/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler temporal',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-pinamar-buenos-aires_2-233'
                },
                {
                    name: 'Alquiler temporario',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-pinamar-buenos-aires_2-233'
                },
                {
                    name: 'Alquiler vacacional',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler vacacional quintas y casas rurales',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-quinta_3/zona-buenos-aires_2'
                },
                {
                    name: 'Apartamentos turisticos',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler duplex o triplex',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-duplex_11/zona-buenos-aires_2'
                },
                {
                    name: 'Departamentos en Alquiler',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Alquiler de cabañas',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-cabana_21/zona-bariloche-rio-negro_16-600'
                },
                {
                    name: 'Alquiler de casas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-buenos-aires_2'
                },
                {
                    name: 'Alquiler salón de fiestas',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-pilar-pilar-buenos-aires_2-232-104'
                },
                {
                    name: 'Alquileres en Argentina',
                    route: '/ar/'
                }
            ]
        },
        {
            key: 3,
            routes: [
                {
                    name: 'Casas en Argentina',
                    route: '/ar/buscar/tipo-casa_2'
                },
                {
                    name: 'Departamentos en Argentina',
                    route: '/ar/buscar/tipo-departamento_1'
                },
                {
                    name: 'Quintas en Argentina',
                    route: '/ar/buscar/tipo-quinta_3'
                },
                {
                    name: 'Terrenos en Argentina',
                    route: '/ar/buscar/tipo-terreno_4'
                },
                {
                    name: 'Campos en Argentina',
                    route: '/ar/buscar/tipo-campo_5'
                },
                {
                    name: 'Cocheras en Argentina',
                    route: '/ar/buscar/tipo-cochera_6'
                },
                {
                    name: 'Oficinas en Argentina',
                    route: '/ar/buscar/tipo-oficina_7'
                },
                {
                    name: 'Galpones en Argentina',
                    route: '/ar/buscar/tipo-galpon_8'
                },
                {
                    name: 'Locales Comerciales en Argentina',
                    route: '/ar/buscar/tipo-local-comercial_9'
                },
                {
                    name: 'PH en Argentina',
                    route: '/ar/buscar/tipo-ph_10'
                },
                {
                    name: 'Duplex en Argentina',
                    route: '/ar/buscar/tipo-duplex_11'
                },
                {
                    name: 'Fondos de Comercio en Argentina',
                    route: '/ar/buscar/tipo-fondo-de-comercio_12'
                },
                {
                    name: 'Islas en Argentina',
                    route: '/ar/buscar/tipo-isla_13'
                },
                {
                    name: 'Hoteles en Argentina',
                    route: '/ar/buscar/tipo-hotel_14'
                },
                {
                    name: 'Garages en Argentina',
                    route: '/ar/buscar/tipo-garage_15'
                },
                {
                    name: 'Chacras en Argentina',
                    route: '/ar/buscar/tipo-chacra_16'
                },
                {
                    name: 'Complejo Turístico en Argentina',
                    route: '/ar/buscar/tipo-complejo-turistico_17'
                },
                {
                    name: 'Triplex en Argentina',
                    route: '/ar/buscar/tipo-triplex_18'
                },
                {
                    name: 'Edificio en Argentina',
                    route: '/ar/buscar/tipo-edificio_19'
                },
                {
                    name: 'Loft en Argentina',
                    route: '/ar/buscar/tipo-loft_20'
                },
                {
                    name: 'Cabañas en Argentina',
                    route: '/ar/buscar/tipo-cabana_21'
                },
                {
                    name: 'Otros inmuebles en Argentina',
                    route: '/ar/buscar/tipo-otro-inmueble_22'
                },
                {
                    name: 'Pagina de alquiler vacacional',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-pinamar-pinamar-buenos-aires_2-233-1090'
                },
                {
                    name: 'Página de alquileres para vivienda',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-buenos-aires_2'
                },
                {
                    name: 'Pagina de alquiler de departamentos',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-belgrano-capital-federal_1-93'
                },
                {
                    name: 'Precio de alquileres en Buenos Aires',
                    route: '/ar'
                },
                {
                    name: 'Alquiler departamentos temporarios o vacacionales',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-pinamar-pinamar-buenos-aires_2-233-1090'
                },
                {
                    name: 'Inmobiliarias para alquileres',
                    route: '/ar'
                },
                {
                    name: 'Casas alquiler en Buenos Aires',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-buenos-aires_2'
                },
                {
                    name: 'Casas baratas alquiler en Buenos Aires',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-buenos-aires_2'
                },
                {
                    name: 'Departamentos alquiler en Buenos Aires',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-buenos-aires_2'
                },
                {
                    name: 'Departamentos alquiler en Capital Federal',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Departamentos alquiler en La Plata',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-la-plata-buenos-aires_2-202'
                },
                {
                    name: 'Departamentos temporarios en Buenos Aires',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-buenos-aires_2'
                },
                {
                    name: 'Alquileres en Capital Federal',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Departamentos alquileres en la costa ',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-villa-gesell-villa-gesell-buenos-aires_2-268-1111'
                },
                {
                    name: 'Casas alquileres Zona Norte',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-pilar-pilar-buenos-aires_2-232-104'
                },
                {
                    name: 'Casas alquiler en Zona Norte',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-casa_2/zona-san-isidro-buenos-aires_2-79'
                },
                {
                    name: 'Departamentos alquiler temporario',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Departamentos alquiler Caballito',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-caballito-capital-federal_1-18'
                },
                {
                    name: 'Departamentos alquiler Capital Federal',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-capital-federal_1'
                },
                {
                    name: 'Departamentos alquiler Palermo',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-palermo-capital-federal_1-46'
                },
                {
                    name: 'Departamentos alquiler Recoleta',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-recoleta-capital-federal_1-116'
                },
                {
                    name: 'Departamentos alquiler en Rosario',
                    route: '/ar/buscar/operacion-alquiler_2/tipo-departamento_1/zona-rosario-rosario-santa-fe_21-312-1948'
                },
                {
                    name: 'Departamentos alquiler temporario o vacacional en Pinamar',
                    route: '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-pinamar-buenos-aires_2-233'
                },
                {
                    name: 'Departamentos alquiler temporario o vacacional en Mar del Plata',
                    route:
                        '/ar/buscar/operacion-alquiler-temporario_3/tipo-departamento_1/zona-mar-del-plata-general-pueyrredon-buenos-aires_2-189-973'
                }
            ]
        }
    ]
}

const es = {
    id: 2,
    name: 'España',
    code: 'ES',
    flag: '/img/es.svg',
    headerLogo: '/img/logo-home.svg',
    headerImage: '/img/homebg-01.jpg',
    header1: 'La manera más simple de buscar tu propiedad.',
    header2: 'Comienza ahora.',
    header3: appSettings.appName,
    head: {
        tHome: 'Pisos en venta, alquiler temporal o permanente, casas, oficinas, apartamentos, locales, campos y más inmuebles: ' + appSettings.appName,
        dHome:
            'Pisos en venta, alquiler temporal y permanente. Apartamentos alquiler temporal. Casas y pisos en venta y alquiler. Venta y Alquiler de locales y naves. Miles de ciudades para buscar propiedades.',
        tSearch: 'Es fácil encontrar propiedades: pisos, casas, oficinas, locales, naves y más en ' + appSettings.appName,
        dSearch:
            'Miles de propiedades en venta o alquiler: apartamentos vacacionales, pisos y casas en alquiler temporal o permanente, pisos de alquiler, locales y naves.'
    },
    search: {
        title: 'Encontrá tu propiedad facilmente en ' + appSettings.appName ,
        text:
            'Podés filtrar por Zona, Precio, Tipo de propiedad, Operación y más. Es fácil contactarte y decidir.'
    },
    contentTabs: [
        {
            key: 1,
            routes: [
                {
                    name: 'Alquiler apartamentos baratos en linea de playa',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31/'
                },
                {
                    name: 'Alquiler apartamentos vacacionales Alicante y ciudades de España',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Alquiler local comercial Barcelona',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-barcelona_25'
                },
                {
                    name: 'Alquiler locales comerciales Valencia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-valencia_72'
                },
                {
                    name: 'Alquiler locales Barcelona ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-barcelona_25'
                },
                {
                    name: 'Alquiler nave industrial  Madrid',
                    route: '/es/buscar/operacion-alquiler_2/tipo-nave-industrial_8/zona-madrid_30'
                },
                {
                    name: 'Alquiler oficina Valencia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-oficina_7/zona-valencia_72/'
                },
                {
                    name: 'Alquiler pisos Barcelona',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-barcelona_25'
                },
                {
                    name: 'Alquiler pisos Madrid',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Alquiler pisos Malaga',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-malaga_57'
                },
                {
                    name: 'Alquiler pisos Murcia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-murcia_58'
                },
                {
                    name: 'Alquiler pisos Vigo',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-vigo-vigo-pontevedra_63-1035-15123'
                },
                {
                    name: 'Alquiler pisos para empresas Madrid',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Alquiler Cadiz',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-cadiz_38'
                },
                {
                    name: 'Alquiler local comercial Guadalajara',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-guadalajara_48'
                },
                {
                    name: 'Alquiler local comercial Murcia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-murcia_58'
                },
                {
                    name: 'Alquiler local comercial Valencia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-valencia_72'
                },
                {
                    name: 'Alquiler local comercial Vigo',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-vigo-pontevedra_63-1035'
                },
                {
                    name: 'Alquiler pisos Almería',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-almeria_32'
                },
                {
                    name: 'Alquiler temporario Alicante España',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Paginas de alquiler de pisos en España',
                    route: '/es'
                }
            ]
        },
        {
            key: 2,
            routes: [
                {
                    name: 'Alicante alquiler temporario',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Alicante pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Barcelona casas en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-casa_2/zona-barcelona_25'
                },
                {
                    name: 'Barcelona locales en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-barcelona_25'
                },
                {
                    name: 'Barcelona pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-barcelona_25'
                },
                {
                    name: 'Cádiz pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-cadiz_38'
                },
                {
                    name: 'España alquiler vacacional de pisos',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'España pisos en alquiler',
                    route: '/es'
                },
                {
                    name: 'La Campiña Guadalajara Locales comerciales en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-la-campina-guadalajara_48-884'
                },
                {
                    name: 'Las Palmas de Gran Canaria pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-las-palmas_62'
                },
                {
                    name: 'Madrid centro pisos en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Madrid centro pisos en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid-madrid_30-707'
                },
                {
                    name: 'Madrid nave industrial en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-nave-industrial_8/zona-madrid_30'
                },
                {
                    name: 'Madrid pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Malaga pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-malaga_57'
                },
                {
                    name: 'Paginas de alquiler de viviendas en España',
                    route: '/es'
                },
                {
                    name: 'Valencia casas en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-casa_2/zona-valencia_72'
                },
                {
                    name: 'Valencia locales en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-valencia_72'
                },
                {
                    name: 'Valencia oficinas en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-oficina_7/zona-valencia_72'
                },
                {
                    name: 'Vigo pisos en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-vigo-vigo-pontevedra_63-1035-15123 '
                }
            ]
        },
        {
            key: 3,
            routes: [
                {
                    name: 'Alquiler apartamentos vacaciones ',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Alquiler de casas para empresas',
                    route: '/es/buscar/operacion-alquiler_2/tipo-casa_2/zona-barcelona_25'
                },
                {
                    name: 'Alquiler de oficina en Valencia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-oficina_7/zona-valencia_72'
                },
                {
                    name: 'Naves en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-nave-industrial_8/zona-madrid_30'
                },
                {
                    name: 'Alquiler pisos en España',
                    route: '/es'
                },
                {
                    name: 'Alquiler pisos Madrid',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid-madrid_30-707'
                },
                {
                    name: 'Alquiler pisos Madrid centro',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Alquiler temporal para empresas',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Casas en alquiler Valencia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-casa_2/zona-valencia_72'
                },
                {
                    name: 'Locales comerciales en La Campiña Guadalajara',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-la-campina-guadalajara_48-884'
                },
                {
                    name: 'Locales en alquiler en Barcelona baratos',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-barcelona_25'
                },
                {
                    name: 'Locales en alquiler Valencia',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-valencia_72'
                },
                {
                    name: 'Paginas de alquiler de viviendas en España',
                    route: '/es'
                },
                {
                    name: 'Pisos alquiler Alicante',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Pisos alquiler Barcelona',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-barcelona_25'
                },
                {
                    name: 'Pisos alquiler Cádiz',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-cadiz_38'
                },
                {
                    name: 'Pisos alquiler Las Palmas de Gran Canaria',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-las-palmas_62'
                },
                {
                    name: 'Pisos alquiler Madrid',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Pisos alquiler Malaga',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-malaga_57'
                },
                {
                    name: 'Pisos alquiler vacacional en España',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Pisos alquiler Vigo',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-vigo-vigo-pontevedra_63-1035-15123'
                }
            ]
        }
    ]
}

const uy = {
    id: 3,
    name: 'Uruguay',
    code: 'UY',
    flag: '/img/uy.svg',
    headerLogo: '/img/logo-home.svg',
    headerImage: '/img/homebg-01.jpg',
    header1: 'La manera más simple de buscar tu propiedad.',
    header2: 'Comienza ahora.',
    header3: appSettings.appName,
    head: {
        tHome: 'Departamentos en venta o alquiler temporario o anual, apartamentos, casas, chacras, oficinas, locales y más inmuebles: ' + appSettings.appName,
        dHome:
            'Departamentos en venta, alquiler o alquiler temporario en Punta del Este y Uruguay. Apartamentos por temporada, anual o permanente. Chacra y casas en alquiler temporario.',
        tSearch: 'Es fácil encontrar ventas y alquileres: apartamentos, casas, oficinas, locales, chacras y más en ' + appSettings.appName,
        dSearch:
            'Miles de propiedades en venta o alquiler: apartamentos por temporada, chacras y casas en alquiler temporal, permanente o anual en Punta del Este y Uruguay.'
    },
    search: {
        title: 'Encontrá tu propiedad facilmente en ' + appSettings.appName ,
        text:
            'Podés filtrar por Zona, Precio, Tipo de propiedad, Operación y más. Es fácil contactarte y decidir.'
    },
    contentTabs: [
        {
            key: 1,
            routes: [
                {
                    name: 'Alquileres Punta del Este todo el año',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler apartamentos Punta del Este anual',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler casa Punta del Este anual',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler apartamentos Punta del Este por dia (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler casas Punta del Este por día (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler apartamento Punta del Este (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler temporada Punta del Este apartamentos',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler casa Punta del Este por día, Punta Ballena (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-ballena-punta-del-este-maldonado_81-1212-18359'
                },
                {
                    name: 'Alquiler casa Punta del Este por día, La Barra (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-la-barra-barra-de-maldonado-maldonado_81-1325-18329'
                },
                {
                    name: 'Alquiler casa Punta del Este por día, Playa Mansa (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Alquiler casa Beverly Hills por día, Punta del Este (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-beverly-hills-punta-del-este-maldonado_81-1212-18310'
                },
                {
                    name: 'Alquiler casa Barra de Maldonado por día, Punta del Este (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Alquiler casa José Ignacio por día, Punta del Este (Temporario)',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-jose-ignacio-barra-de-maldonado-maldonado_81-1325-18326'
                },
                {
                    name: 'Alquiler apartamento Península por día, Punta del Este',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-peninsula-punta-del-este-maldonado_81-1212-18290'
                },
                {
                    name: 'Alquiler apartamento Playa Mansa por día, Punta del Este (Temporario)',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Alquiler apartamento Playa Brava por día, Punta del Este (Temporario)',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-brava-punta-del-este-maldonado_81-1212-18316'
                },
                {
                    name: 'Alquiler apartamento Barra de Maldonado por día, Punta del Este (Temporario)',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Alquiler chacra en Punta del Este por temporada',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-chacra_16/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler chacra en José Ignacio, Punta del Este (Temporario)',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-chacra_16/zona-jose-ignacio-barra-de-maldonado-maldonado_81-1325-18326'
                },
                {
                    name: 'Alquileres departamentos Punta del Este Anual',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler temporario o vacacional en Punta del Este ',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler temporario en Punta del Este',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-peninsula-punta-del-este-maldonado_81-1212-18290'
                },
                {
                    name: 'Alquiler temporal departamentos en Playa Mansa, Punta del Este',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Alquiler temporal departamentos en Playa Brava, Punta del Este',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-brava-punta-del-este-maldonado_81-1212-18316'
                }
            ]
        },
        {
            key: 2,
            routes: [
                {
                    name: 'Punta del Este alquiler casa',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Punta del Este alquiler apartamentos',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Punta del Este alquiler casas temporal',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Punta del Este alquiler apartamento por día',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Punta Ballena, Punta del Este alquiler casa temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-ballena-punta-del-este-maldonado_81-1212-18359'
                },
                {
                    name: 'La Barra, Punta del Este alquiler casa temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-la-barra-barra-de-maldonado-maldonado_81-1325-18329'
                },
                {
                    name: 'Playa Mansa, Punta del Este alquiler casa temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Beverly Hills, Punta del Este alquiler casa temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-beverly-hills-punta-del-este-maldonado_81-1212-18310'
                },
                {
                    name: 'Barra de Maldonado, Punta del Este alquiler casa temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'José Ignacio, Punta del Este alquiler casa temporario',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-jose-ignacio-barra-de-maldonado-maldonado_81-1325-18326'
                },
                {
                    name: ' Península, Punta del Este alquiler apartamento temporario',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-peninsula-punta-del-este-maldonado_81-1212-18290'
                },
                {
                    name: 'Playa Mansa, Punta del Este alquiler apartamento temporario',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Playa Brava, Punta del Este alquiler apartamento temporario',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-brava-punta-del-este-maldonado_81-1212-18316'
                },
                {
                    name: 'Barra de Maldonado, Punta del Este alquiler apartamento temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Punta del Este alquiler chacra por temporada',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-chacra_16/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'José Ignacio, Punta del Este alquiler chacra por temporada',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-chacra_16/zona-jose-ignacio-barra-de-maldonado-maldonado_81-1325-18326'
                },
                {
                    name: 'Punta del Este alquiler anual departamentos',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Punta del Este alquiler deparamentos temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Península, Punta del Este, alquiler departamentos por día',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-peninsula-punta-del-este-maldonado_81-1212-18290'
                },
                {
                    name: 'Playa Mansa, Punta del Este, alquiler departamentos por día',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Playa Brava, Punta del Este, alquiler departamentos temporario',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-brava-punta-del-este-maldonado_81-1212-18316'
                },
                {
                    name: 'Barra de Maldonado, Punta del Este, alquiler departamento temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Uruguay, Punta del Este, casas en alquiler por temporada',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Uruguay, Punta del Este, alquiler apartamentos por día',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                }
            ]
        },
        {
            key: 3,
            routes: [
                {
                    name: ' Alquiler Punta del Este casa',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: ' Alquiler Punta del Este apartamento',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Casa alquiler Punta del Este, Maldonado',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Apartamento alquiler Punta del Este, Maldonado',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Casa alquiler Punta del Este, Punta Ballena',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-punta-ballena-punta-del-este-maldonado_81-1212-18359'
                },
                {
                    name: 'Casa alquiler, Punta del Este, La Barra',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-la-barra-barra-de-maldonado-maldonado_81-1325-18329'
                },
                {
                    name: 'Casa alquiler Punta del Este, Playa Mansa',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Casa alquiler Punta del Este, Beverly Hills',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-beverly-hills-punta-del-este-maldonado_81-1212-18310'
                },
                {
                    name: 'Casa alquiler Punta del Este, Barra de Maldonado',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Casa alquiler Punta del Este, José Ignacio',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-casa_2/zona-jose-ignacio-barra-de-maldonado-maldonado_81-1325-18326'
                },
                {
                    name: 'Apartamento alquiler Punta del Este, Península',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-peninsula-punta-del-este-maldonado_81-1212-18290'
                },
                {
                    name: 'Apartamento alquiler Punta del Este, Playa Mansa',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Apartamento alquiler Punta del Este, Playa Brava',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-brava-punta-del-este-maldonado_81-1212-18316'
                },
                {
                    name: 'Apartamento alquiler Punta del Este,  Barra de Maldonado',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Chacra Alquiler Punta del Este, temporario',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-chacra_16/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Chacra Alquiler Punta del Este,  Barra de Maldonado',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-chacra_16/zona-jose-ignacio-barra-de-maldonado-maldonado_81-1325-18326'
                },
                {
                    name: 'Departamentos alquiler, Punta del Este todo el año',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Departamentos alquiler, Punta del Este',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Departamentos alquiler Punta del Este, Península',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-peninsula-punta-del-este-maldonado_81-1212-18290'
                },
                {
                    name: 'Departamentos alquiler Punta del Este,  Playa Mansa',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-mansa-punta-del-este-maldonado_81-1212-18317'
                },
                {
                    name: 'Departamentos alquiler Punta del Este, Playa Brava',
                    route:
                        '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-playa-brava-punta-del-este-maldonado_81-1212-18316'
                },
                {
                    name: 'Departamentos alquiler Punta del Este, Barra de Maldonado',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-barra-de-maldonado-maldonado_81-1325'
                },
                {
                    name: 'Alquileres en Punta del Este todo el año',
                    route: '/uy/buscar/operacion-alquiler_2/tipo-casa_2/zona-punta-del-este-maldonado_81-1212'
                },
                {
                    name: 'Alquiler de apartamentos en Punta del Este',
                    route: '/uy/buscar/operacion-alquiler-temporada_3/tipo-apartamento_1/zona-punta-del-este-maldonado_81-1212'
                }
            ]
        }
    ]
}

const cl = {
    id: 4,
    name: 'Chile',
    code: 'CL',
    flag: '/img/cl.svg',
    headerLogo: '/img/logo-home.svg',
    headerImage: '/img/homebg-01.jpg',
    header1: 'La manera más simple de buscar tu propiedad.',
    header2: 'Comienza ahora.',
    header3: appSettings.appName,
    head: {
        tHome: 'Ventas y Arriendos en Santiago y Chile, departamentos en arriendo, casas, oficinas, locales y más inmuebles: ' + appSettings.appName,
        dHome:
            'Ventas y Arriendos en Santiago Centro. Departamentos en arriendo Santiago. Locales en arriendo, oficinas en arriendo, casas en arriendo únicas en Viña del Mar y Chile.',
        tSearch: 'Es fácil encontrar venta o arriendo: departamentos, casas, oficinas, locales y más en ' + appSettings.appName,
        dSearch:
            'Miles de propiedades en vemta y arriendo temporal o anual: departamentos y casas en Santiago y Chile. Arriendos de casas, departamentos y oficinas.'
    },
    search: {
        title: 'Encontrá tu propiedad facilmente en ' + appSettings.appName ,
        text:
            'Podés filtrar por Zona, Precio, Tipo de propiedad, Operación y más. Es fácil contactarte y decidir.'
    },
    contentTabs: [
        {
            key: 1,
            routes: [
                {
                    name: 'Arriendo departamento Santiago, Metropolitana',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamento Valparaíso',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-valparaiso_103'
                },
                {
                    name: 'Arriendo departamento Viña del Mar y Valparaíso ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-valparaiso_103'
                },
                {
                    name: 'Arriendo departamento Bío Bío ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-bio-bio_108'
                },
                {
                    name: 'Arriendo casa Santiago, en área Metropolitana ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-casa_2/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo casa Bío Bío ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-casa_2/zona-bio-bio_108'
                },
                {
                    name: 'Arriendo oficina Santiago, área Metropolitana',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo Local comercial Bío Bío ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-local-comercial_9/zona-bio-bio_108'
                },
                {
                    name: 'Arriendo Valparaíso casa por día (Temporario)',
                    route: '/cl/buscar/operacion-arriendo-temporal_3/tipo-casa_2/zona-valparaiso_103'
                },
                {
                    name: 'Arriendo departamento Coquimbo por día (Temporario)',
                    route: '/cl/buscar/operacion-arriendo-temporal_3/tipo-departamento_1/zona-coquimbo_102'
                },
                {
                    name: 'Arriendo departamentos Santiago centro ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamentos un ambiente Santiago barato',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendos de departamentos en Santiago de Chile baratos ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamento Santiago centro 2 dormitorios',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamento 3 dormitorios Santiago',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo oficina pequeña Santiago centro',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo oficina pleno centro Santiago de Chile',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo oficina Santiago centro barato',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo de oficinas Santiago centro ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Alquileres en Chile',
                    route: '/cl/'
                },
                {
                    name: 'Alquiler departamentos en Chile',
                    route: '/cl/'
                },
                {
                    name: 'Alquiler por día en Valparaíso y Viña del Mar',
                    route: '/cl/buscar/operacion-arriendo-temporal_3/tipo-casa_2/zona-valparaiso_103'
                }
            ]
        },
        {
            key: 2,
            routes: [
                {
                    name: 'Alicante alquiler temporario',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Alicante pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'Barcelona casas en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-casa_2/zona-barcelona_25'
                },
                {
                    name: 'Barcelona locales en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-barcelona_25'
                },
                {
                    name: 'Barcelona pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-barcelona_25'
                },
                {
                    name: 'Cádiz pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-cadiz_38'
                },
                {
                    name: 'España alquiler vacacional de pisos',
                    route: '/es/buscar/operacion-alquiler-temporario_3/tipo-piso_1/zona-alicante_31'
                },
                {
                    name: 'España pisos en alquiler',
                    route: '/es'
                },
                {
                    name: 'La Campiña Guadalajara Locales comerciales en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-la-campina-guadalajara_48-884'
                },
                {
                    name: 'Las Palmas de Gran Canaria pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-las-palmas_62'
                },
                {
                    name: 'Madrid centro pisos en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Madrid centro pisos en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid-madrid_30-707'
                },
                {
                    name: 'Madrid nave industrial en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-nave-industrial_8/zona-madrid_30'
                },
                {
                    name: 'Madrid pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-madrid_30'
                },
                {
                    name: 'Malaga pisos en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-malaga_57'
                },
                {
                    name: 'Paginas de alquiler de viviendas en España',
                    route: '/es'
                },
                {
                    name: 'Valencia casas en alquiler ',
                    route: '/es/buscar/operacion-alquiler_2/tipo-casa_2/zona-valencia_72'
                },
                {
                    name: 'Valencia locales en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-local-comercial_9/zona-valencia_72'
                },
                {
                    name: 'Valencia oficinas en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-oficina_7/zona-valencia_72'
                },
                {
                    name: 'Vigo pisos en alquiler',
                    route: '/es/buscar/operacion-alquiler_2/tipo-piso_1/zona-vigo-vigo-pontevedra_63-1035-15123'
                }
            ]
        },
        {
            key: 3,
            routes: [
                {
                    name: 'Departamento en arriendo Santiago area metropolitana',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Departamento arriendo Valparaíso',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-valparaiso_103'
                },
                {
                    name: 'Departamento arriendo Viña del Mar y Valparaíso',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-valparaiso_103'
                },
                {
                    name: 'Departamento arriendo Bío Bío',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-bio-bio_108'
                },
                {
                    name: 'Casa arriendo Santiago, Metropolitana',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-casa_2/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Casa arriendo Bío Bío',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-casa_2/zona-bio-bio_108'
                },
                {
                    name: 'Oficina arriendo Santiago de Chile, Metropolitana',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Local comercial arriendo Bío Bío',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-local-comercial_9/zona-bio-bio_108'
                },
                {
                    name: 'Casa arriendo Valparaíso (Temporario)',
                    route: '/cl/buscar/operacion-arriendo-temporal_3/tipo-casa_2/zona-valparaiso_103'
                },
                {
                    name: 'Departamento arriendo Coquimbo (Temporario)',
                    route: '/cl/buscar/operacion-arriendo-temporal_3/tipo-departamento_1/zona-coquimbo_102'
                },
                {
                    name: 'Departamentos en arriendo santiago centro ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamentos un ambiente Santiago barato',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendos de departamentos en Santiago de Chile baratos ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamento Santiago centro 2 dormitorios',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo departamento 3 dormitorios Santiago',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-departamento_1/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo oficina pequeña Santiago centro',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo oficina pleno centro Santiago de Chile',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo oficina Santiago centro barato',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Arriendo de oficinas Santiago centro ',
                    route: '/cl/buscar/operacion-arriendo_2/tipo-oficina_7/zona-santiago-metropolitana_104-1370'
                },
                {
                    name: 'Alquileres en Chile',
                    route: '/cl/'
                },
                {
                    name: 'Alquiler departamentos en Chile',
                    route: '/cl/'
                },
                {
                    name: 'Alquiler por día en Valparaíso y Viña del Mar',
                    route: '/cl/buscar/operacion-arriendo-temporal_3/tipo-casa_2/zona-valparaiso_103'
                }
            ]
        }
    ]
}

export { ar, es, uy, cl }
